module.exports = __webpack_public_path__ + "static/media/left_arrow_table.24c2c5b5.svg";